import type { Feature } from '@luna/gatekeeper';

export const repaymentMethodChange: Feature = {
    enabled: false,
    _description: 'Enable redirection based repayment change',
};
